import React from 'react'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import FormHelperText from '@material-ui/core/FormHelperText'
import Typography from '@material-ui/core/Typography'
import clsx from 'clsx'
import { Controller } from 'react-hook-form'
import InfoAlert from 'components/info-alert'
import { usePillChipFieldStyles } from './pill-chip-field-styles'

export const formatIncrementLabel = label => {
  const match = String(label).match(/(\d+)/)

  return match ? `${match[1]} min` : label
}

const StartTimeIncrementField = ({
  control,
  errors,
  startTimeIncrementOptions,
}) => {
  const classes = usePillChipFieldStyles()
  const defaultValue =
    startTimeIncrementOptions.find(option => option.default)?.value ??
    startTimeIncrementOptions[0]?.value

  return (
    <>
      <Controller
        name="startTimeIncrementInMinutes"
        control={control}
        defaultValue={defaultValue}
        render={({ onChange, value }) => (
          <Box className={classes.chipRow}>
            {startTimeIncrementOptions.map(option => {
              const isSelected = Number(value) === Number(option.value)

              return (
                <Button
                  key={option.value}
                  type="button"
                  data-cy="startTimeInterval"
                  data-value={option.value}
                  className={clsx(
                    classes.chip,
                    isSelected && classes.chipSelected,
                  )}
                  onClick={() => onChange(option.value)}
                >
                  {formatIncrementLabel(option.label)}
                </Button>
              )
            })}
          </Box>
        )}
      />
      {errors?.startTimeIncrementInMinutes ? (
        <FormHelperText error>
          A start time increment is required to create a booking type
        </FormHelperText>
      ) : null}
      <InfoAlert mt={2}>
        <Typography variant="body2">
          Increments are based on your availability at the selected location.
          Shorter increments give students more options but can fragment your
          day.
        </Typography>
      </InfoAlert>
    </>
  )
}

export default StartTimeIncrementField
